import clsx from 'clsx';
import { ConsoleLevelType } from 'types/error-log';
import { formatClockTime } from 'utils/error-log/format';
import { parseConsoleSnapshot } from 'utils/error-log/parse-error-log-blobs';

type ErrorLogConsoleViewProps = {
  entries: unknown;
};

const LEVEL_CLASSES: Record<ConsoleLevelType, string> = {
  error: 'bg-red-100 text-red-800',
  warn: 'bg-amber-100 text-amber-800',
  info: 'bg-blue-100 text-blue-800',
  debug: 'bg-gray-100 text-gray-600',
  log: 'bg-gray-100 text-gray-700'
};

export default function ErrorLogConsoleView({
  entries
}: ErrorLogConsoleViewProps) {
  const parsed = parseConsoleSnapshot(entries);
  if (!parsed || parsed.length === 0) {
    return (
      <div className='text-sm text-gray-400'>No console output recorded.</div>
    );
  }

  return (
    <ol className='divide-y divide-gray-800 rounded-md bg-gray-900 font-mono text-xs text-gray-100'>
      {parsed.map((entry) => (
        <li
          key={entry.id}
          className={clsx(
            'flex items-start gap-3 px-3 py-1.5',
            entry.level === 'error' && 'bg-red-950/40',
            entry.level === 'warn' && 'bg-amber-950/30'
          )}
        >
          <span className='shrink-0 text-gray-500'>
            {formatClockTime(entry.timestamp)}
          </span>
          <span
            className={clsx(
              'shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase',
              LEVEL_CLASSES[entry.level] ?? LEVEL_CLASSES.log
            )}
          >
            {entry.level}
          </span>
          <pre className='min-w-0 flex-1 whitespace-pre-wrap break-words'>
            {entry.message}
          </pre>
        </li>
      ))}
    </ol>
  );
}
